// extracted by mini-css-extract-plugin
export default {"connection":"ConnectionCloneModal_connection__ObEMS","icon":"ConnectionCloneModal_icon__W53gC"};